import { ADMITAD_QUERY_PARAM_NAME } from '@analytics/const';
import { Inject, Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HOST } from '@core/const';
import { CookieService } from '@core/feature';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AdmitadAnalyticsService implements OnDestroy {
  private subscription = new Subscription();

  constructor(
    private cookieService: CookieService,
    private route: ActivatedRoute,
    @Inject(HOST) private host: string,
  ) {}

  init(): void {
    this.subscription.add(
      this.route.queryParamMap
        .pipe(
          map((queryParamMap) => queryParamMap.get(ADMITAD_QUERY_PARAM_NAME)),
          filter((admitadUid) => typeof admitadUid === 'string'),
        )
        .subscribe((admitadUid: string) => {
          const expires = new Date();
          expires.setDate(expires.getDate() + 90);

          this.cookieService.put('_aid', admitadUid, {
            expires,
            path: '/',
            secure: true,
            domain: this.getCookieDomain(),
          });
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Эта кука обязательно должна прилететь на бекенд. Так как бекенд находится на другом поддомене,
   * кука должна лежать на домене верхнего уровня.
   */
  private getCookieDomain(): string | undefined {
    const parts = this.host.split('.');

    return '.' + parts.slice(-2).join('.');
  }
}
